<template>
  <Accordion :is-full="true">
    <template
        v-for="(item, idx) in content"
        :key="`acc-item-${idx}`"
    >
      <Accordion-element
          :ref="`acc-${idx}`"
          :ref-name="`acc-${idx}`"
          @open="onAccordionOpen"
          :title="item.title"
          :is-full="true"
      >
        <template v-if="item.isDocs">
          <table-docs-template :items="item.items"></table-docs-template>
        </template>
        <template v-else>
          <table-default-template :key="`acc-${idx}-def`" :items="item.items"></table-default-template>
        </template>
      </Accordion-element>
    </template>
  </Accordion>
</template>

<script>
import Accordion from '../../../../storybook/Accordion.vue';
import AccordionElement from '../../../../storybook/AccordionItem.vue';
import TableDocsTemplate from './TableDocsTemplate.vue'
import TableDefaultTemplate from './TableDefaultTemplate.vue'
export default {
  name: 'MainComponent',
  components: {
    Accordion,
    AccordionElement,
    TableDocsTemplate,
    TableDefaultTemplate
  },
  props: {
    items: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      content: []
    };
  },
  methods: {
    onAccordionOpen(refName) {
      // закртыие неактивных вкладок
      // for (let key in this.$refs) {
      //   if (/acc/ig.test(key) && key !== refName) {
      //     if (typeof this.$refs[key].isOpen === 'undefined') {
      //       this.$refs[key][0].isOpen = false;
      //     } else {
      //       this.$refs[key].isOpen = false;
      //     }
      //   }
      // }
    },
    prepareData() {
      this.items.forEach((item) => {
        const finalItem = {};
        finalItem.title = item.title;

        if(item?.items?.length) {
          if(item?.items[0]?.code === 'documents') {
            finalItem.isDocs = true;
            finalItem.items = item?.items[0]?.props?.files;
          } else {
            finalItem.isDocs = false;
            finalItem.items = item?.items;
          }
        }

        this.content.push(finalItem);
      });
    }
  },
  mounted() {
    this.prepareData();
  }
}
</script>